<template>
  <v-dialog v-model="dialog" max-width="1000" @click:outside="$emit('changeValue', false)">
    <v-card>
      <v-card-title>Pré Importação</v-card-title>

      <v-data-table class="px-6" :headers="headers" :items="indicesPreview" :search.sync="search">
        <template v-slot:[`item.codigo`]="{ item }">{{ item.codigo }}</template>
        <template v-slot:[`item.variacao`]="{ item }">{{ item.variacao }}</template>
      </v-data-table>

      <v-card-actions>
        <v-col>
          <v-btn color="green" :loading="loading" style="float: right" @click="processarImportacao(arquivoId)">Importar</v-btn>
        </v-col>
        <v-btn color="green" style="float: right" @click="$emit('changeValue', false)">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import IndicesCOGE from '@/services/IndicesCOGEService';

  export default {
    props: {
      showDialog: {
        type: Boolean,
        required: true
      },
      indicesPreview: {
        type: Array,
        required: true
      },
      arquivoId: {
        type: Number,
        required: true
      }
    },

    emits: ['changeValue'],

    data() {
      return {
        search: '',
        dialog: false,
        loading: false,
        headers: [
          {
            text: 'Códigos',
            value: 'codigo'
          },
          {
            text: 'Variação',
            value: 'variacao'
          }
        ]
      };
    },

    methods: {
      processarImportacao(arquivoId) {
        this.loading = true;
        IndicesCOGE.processarImportacao(arquivoId)
          .then((response) => {
            this.$toast.success(response.data.msg, '', { position: 'topRight' });
            this.$router.push({ name: 'Indice COGE Histórico' });
          })
          .catch((err) => {
            this.$toast.erro('Erro ao importar Indice COGE', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            this.dialog = false;
          });
      }
    },

    watch: {
      showDialog(newValue) {
        this.dialog = newValue;
      }
    }
  };
</script>
